// Generated from src/img/svg/elevator_broken.svg

export const ElevatorBroken = (props) => {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path d="M0 0h24v24H0Z" style={{ fill: "none" }} />
      <path
        d="M12 0a11.9 11.9 0 0 0-7.6 2.7 13.7 13.7 0 0 0-1.7 1.7 12 12 0 0 0 16.9 16.9l1.7-1.7A12 12 0 0 0 12 0m-.7 20.2H7.1a.9.9 0 0 1-.9-.9V4.7a.9.9 0 0 1 .9-.9h4.2Zm6.5-.9a.9.9 0 0 1-.9.9h-4.2V3.8h4.2a.9.9 0 0 1 .9.9Zm-7.5-8.4-.5-.5-1.1 1-1-1-.5.5 1.5 1.6Z"
        style={{ fill: "#353535" }}
      />
      <path
        d="m21.3 19.6-1.7 1.7L2.7 4.4a13.7 13.7 0 0 1 1.7-1.7Z"
        style={{ fill: "#e30613" }}
      />
    </svg>
  );
};
